import { FormBlock } from "@/components/FormBuilder/types";
import {
  useFormFieldGroup,
  useFormSection,
  useTextField
} from "@/components/FormBuilder/Helpers";

export const roofStructureFormSchema: FormBlock[] = [
  ...useFormSection([
    ...useFormFieldGroup(
      [
        useTextField({
          key: "label",
          label: "Label",
          required: true,
          placeholder: "Enter label"
        }),
        useTextField({
          key: "value",
          label: "Value",
          required: true,
          placeholder: "Enter value"
        })
      ],
      { layout: "2-col" }
    )
  ])
];
